// TopBanner.js
import { defineComponent } from "/Scripts/vue.esm-browser.js";
const html = String.raw;

export default defineComponent({
  name: "TopBanner",
  props: {},
  inject: ["dept"],
  emits: [],
  setup(props, { emit }) {},
  template: html`
    <div class="kv">
      <div class="kv_title">
        <div class="kv_lighting">
          <img
            loading="eager"
            src="/action/theme/clearanceSale/V2/images/kv/title-lightning.png"
            alt=""
          />
        </div>
        <div class="">
          <img
            loading="eager"
            src="/action/theme/clearanceSale/V2/images/kv/title.png"
            alt=""
          />
        </div>
        <div class="text-1">
          <picture>
            <source
              media="(max-width: 576px)"
              srcset="/action/theme/clearanceSale/V2/images/kv/text-1-m.png"
            />
            <img
              loading="eager"
              src="/action/theme/clearanceSale/V2/images/kv/text-1-pc.png"
              alt=""
            />
          </picture>
        </div>
        <div class="clock">
          <div class="hand hour"></div>
          <div class="hand minute"></div>
          <div class="hand second"></div>
          <div class="center-dot"></div>
          <img
            loading="eager"
            src="/action/theme/clearanceSale/V2/images/kv/clock.png"
            alt=""
          />
        </div>
      </div>
      <div class="kv_background">
        <picture>
          <source
            media="(max-width: 576px)"
            srcset="/action/theme/clearanceSale/V2/images/kv/background-m.webp"
          />
          <img
            loading="eager"
            fetchpriority="high"
            src="/action/theme/clearanceSale/V2/images/kv/background.webp"
            alt=""
          />
        </picture>
      </div>
    </div>
  `,
  methods: {},
});
